<div>
    <div class="container margin-bottom-40">
        <div class="border-div" style="margin:0 -15px;">
            <div *ngIf="dataExist">
                <br />
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Brokerage</label>
                            <h6 class="displayvalue">{{brokerage.BrokerageName}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Brokerage URL</label>
                            <h6 class="displayvalue">
                                <p *ngIf="!brokerage.BrokerageURL">-</p>
                                <a *ngIf="brokerage.BrokerageURL" style="cursor:pointer" href="javascript:void(0);" target="_blank" [href]="brokerage.BrokerageURL" popover="{{brokerage.BrokerageURL}}" placement="top" container="body" triggers="mouseenter:mouseleave"> {{brokerage.BrokerageURL ? brokerage.BrokerageURL.substr(0,35)+'..' : '-'}}</a>
                            </h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Property Source URL</label>
                            <h6 class="displayvalue">
                                <p *ngIf="!brokerage.SourceURL">-</p>
                                <a *ngIf="brokerage.SourceURL" style="cursor:pointer" href="javascript:void(0);" target="_blank" [href]="brokerage.SourceURL" popover="{{brokerage.SourceURL}}" placement="top" container="body" triggers="mouseenter:mouseleave"> {{brokerage.SourceURL ? brokerage.SourceURL.substr(0,35)+'..' : '-'}}</a>
                            </h6>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="margin-bottom-0">
                    <label class="bluelabel margin-top-10 margin-bottom-15">Brokers</label>
                    <div class="table-responsive">
                        <table class="table basictable row-border hover">
                            <thead>
                              <tr>
                                <th class="min-width-td">Name</th>
                                <th>Email</th>
                                <th>Direct</th>
                                <th>Mobile</th>
                                <th>Title</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let user of brokerage.PropertyBrokerageBrokersList ;let i = index">
                                <td class="min-width-td">{{user.Name}}</td>
                                <td><a href="mailto:{{user.Email}}">{{user.Email}}</a></td>
                                <td>{{user.Phone|phone}}</td>
                                <td>{{user.AdditionalPhone ? (user.AdditionalPhone|phone) :'-'}}</td>
                                <td>{{user.Title ? user.Title:'-'}}</td>
                              </tr>
                            </tbody>
                            <tfoot>
                                <tr *ngIf="brokerage.PropertyBrokerageBrokersList?.length == 0 ">
                                    <td colspan="7" class="odd no-data-available">
                                        <div class="nodata">
                                            <i class="fa fa-exclamation-triangle icon"></i>
                                            <p>No Data Available</p>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="nodata" *ngIf="!dataExist">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No Data Available</p>
            </div>
        </div>
    </div>
</div>
